<div class="row">
  <div class="col-md-6">
    <fieldset style="border: 0">
      <form #oilDeliveryNoteForm="ngForm" class="form-horizontal">
        <div class="card shadow-sm">
          <div class="card-body">

            <!-- Oil Delivery Note No. -->
            <div class="row mb-3">
              <div class="col-12">
                <app-material-pg-input
                  label="Oil Delivery Note No."
                  type="text"
                  name="number"
                  id="number"
                  tabindex="1"
                  [(ngModel)]="oilDeliveryNote.bdnNumber"
                  [required]="true"
                  [disabled]="edit">
                </app-material-pg-input>
              </div>
            </div>

            <!-- Location -->
            <div class="row mb-3">
              <div class="col-12">
                <app-material-organisation-selector
                  id="location"
                  [disabled]="edit"
                  class="pg-component"
                  [(ngModel)]="selectedPortOrganisation"
                  [organisationLanguage]="'en'"
                  name="location"
                  [organisations]="ports"
                  tabindex="2"
                  [placeholder]="'Location'"
                  [required]="true">
                </app-material-organisation-selector>
              </div>
            </div>

            <!-- Date -->
            <div class="row mb-3">
              <div class="col-12">
                <app-material-offset-date-time
                  label="Date"
                  type="date"
                  [(ngModel)]="oilDeliveryNote.date"
                  name="date"
                  [zoneId]="selectedPortOrganisation?.timezone ?? ''"
                  [(ngModel)]="oilDeliveryNote.date"
                  [disabled]="edit || !selectedPortOrganisation"
                  [required]="true">
                </app-material-offset-date-time>
              </div>
            </div>

            <!-- Vessel & Product -->
            <div class="row mb-3">
              <div class="col-md-6">
                <app-material-auto-complete
                  class="w-100"
                  name="vessel"
                  id="vessel"
                  [disabled]="edit"
                  [formatter]="vesselFormatter"
                  [(ngModel)]="selectedVessel"
                  [items]="vessels"
                  [required]="true"
                  [placeholder]="'Vessel'"
                  tabindex="4">
                </app-material-auto-complete>
              </div>
              <div class="col-md-6">
              <app-material-auto-complete
                class="w-100"
                name="Product"
                id="Product"
                [items]="productName"
                [formatter]="productFormatter"
                [(ngModel)]="oilDeliveryNote.product"
                [placeholder]="'Product'"
                [disabled]="edit"
                [required]="true">
              </app-material-auto-complete>
              </div>
            </div>
            <!-- Quantity & Supplier -->
            <div class="row mb-3">
              <div class="col-md-6">
                <app-material-pg-input
                  class="w-100"
                  label="Quantity"
                  type="number"
                  name="quantity"
                  id="quantity"
                  [(ngModel)]="oilDeliveryNote.quantity"
                  tabindex="6"
                  [required]="true">
                </app-material-pg-input>
              </div>

              <div class="col-md-6">
                <app-material-organisation-selector
                  id="supplier"
                  class="pg-component w-100"
                  [(ngModel)]="selectedSupplierOrganisation"
                  [organisationLanguage]="'en'"
                  name="supplier"
                  [organisations]="supplier"
                  tabindex="7"
                  [placeholder]="'Supplier'"
                  [required]="true">
                </app-material-organisation-selector>
              </div>
            </div>

            <!-- File Upload -->
            <div class="row mb-3">
              <div class="col-12">
                <app-material-chunk-file-uploader
                  [accept]="'.pdf'"
                  id="odnFile"
                  name="odnFile"
                  [(ngModel)]="doc"
                  (ngModelChange)="uploadODNFile($event)"
                  [required]="true"
                  tabindex="8">
                </app-material-chunk-file-uploader>
              </div>
            </div>
            <!-- Buttons -->
            <div class="row mt-4">
              <div class="col-12 d-flex justify-content-end">
                <app-material-pg-button
                  id="delete"
                  class="me-2"
                  (clicked)="remove()"
                  label="Remove">
                </app-material-pg-button>
                <app-material-pg-button
                  id="save"
                  [disabled]="!oilDeliveryNoteForm.form.valid && !valid"
                  (clicked)="save()"
                  label="Save">
                </app-material-pg-button>
              </div>
            </div>
          </div>
        </div>
      </form>
    </fieldset>
  </div>
  @if (oilDeliveryNote && oilDeliveryNote.fileId) {
    <div class="col-md-6">
      <app-material-pdf-viewer [fileId]="oilDeliveryNote.fileId"></app-material-pdf-viewer>
    </div>
  }
</div>
